var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 252,
    viewBox: "0 0 252 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(-6.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 121.5,
    cy: 121.5,
    r: 121.5,
    transform: "translate(11.1 4.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M132.6,252a126,126,0,1,1,126-126A126.113,126.113,0,0,1,132.6,252Zm0-243a117,117,0,1,0,117,117A117.151,117.151,0,0,0,132.6,9Z",
    fill: "#1f1f2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(38.1 31.5)",
    fill: "#febe26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 67.5,
    cy: 67.5,
    r: 67.5,
    transform: "translate(65.1 58.5)",
    fill: "#ac207d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(92.1 85.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(114.6 108)",
    fill: "#ee2761"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 50.9,
    height: 9,
    transform: "translate(7.964 244.296) rotate(-45)",
    fill: "#1f1f2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 9,
    height: 50.9,
    transform: "translate(214.892 214.67) rotate(-45)",
    fill: "#1f1f2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 9,
    height: 27,
    transform: "translate(227.1)",
    fill: "#1f1f2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 171.8,
    height: 9,
    transform: "translate(128.005 122.828) rotate(-45)",
    fill: "#1f1f2e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 27,
    height: 9,
    transform: "translate(231.6 22.5)",
    fill: "#1f1f2e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.f6443ac83721168f911ccdbc53bb5690.svg";
export { ForwardRef as ReactComponent };